import React from 'react';
import { styled, LazyImage } from '@teko/ui';

const Wrapper = styled.div((props) => `
    width: ${props.type === "image" ? "44px" : "fit-content"};
    height: ${props.type === "image" ? "44px" : "fit-content"};
    border: 1px ${props.isActive ? props.theme.brand.primary : "#e0e0e0"} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 8px 0;
    ${props.type !== "image" && "padding: 8px 16px;"}
    color: ${props.isActive ? props.theme.brand.primary : "black"};
    background-color: ${props.isVisible || props.isActive === true ? "#fff" : "#e0e0e0"};

    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;


    cursor: ${props.isVisible || props.isActive === true ? "pointer" : "not-allowed"};
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 4px;
    }
`);
const Value = styled.span``;
const ProductVariant = ({
  option,
  type,
  index,
  onSelectVariant
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    isActive: option.selected,
    isVisible: option.visible,
    type,
    onClick: () => onSelectVariant(option, index)
  }, type === "image" && option.image ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(LazyImage, {
    src: option.image.src,
    alt: option.image.alt
  })) : /* @__PURE__ */ React.createElement(Value, null, option.value));
};

export { ProductVariant };
